import React from 'react';
import Modal from 'react-bootstrap/Modal';


function Login_As_Modal(props) {
    
    return (  
      <>     
        <div >
          <Modal
            {...props} className='main-modal'
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered>
  
            <Modal.Body>
              <p className='modal_txt text-center'>Please</p>
              <p className='text-center' style={{ color: "#FFFF" }}>{props.text}</p>
            </Modal.Body>
  
          </Modal>
  
        </div>
      </>
      
    );
  }
  
  export default Login_As_Modal;
  